import _get from 'lodash/get'

import UTILS from '@/store/utils'

export default {
  methods: {
    isVisible(field, application) {
      return field.visible ? field.visible(application) : true
    },

    isDisabled(field, application) {
      if (typeof field.disabled === 'function') {
        return !!field.disabled(application)
      } else if (field.disabled) {
        return !!field.disabled
      }
    },

    getDisabledFields(field, application) {
      if (typeof field.disabledFields === 'function') {
        return field.disabledFields(application)
      } else if (Array.isArray(field.disabledFields)) {
        return field.disabledFields
      }
    },

    startYear(field, application) {
      if (typeof field.startYear === 'function') {
        return field.startYear(application)
      } else if (field.startYear) {
        return field.startYear
      }
    },

    endYear(field, application) {
      if (typeof field.endYear === 'function') {
        return field.endYear(application)
      } else if (field.endYear) {
        return field.endYear
      }
    },

    getValue(field) {
      // Gets field value from state. NOTE: ID might be nested
      // (e.g. 'client.familyName') so an eval is required to
      // resolve the value.
      try {
        return _get(this, `$store.state.application.${field.apiKey}`)
      } catch (ex) {
        return ''
      }
    },

    getAttrFromField(field, attribute, defaultValue = null) {
      const attr = field[attribute]
      if (typeof attr === 'function') {
        return attr.call(this)
      } else if (attr) {
        return attr
      } else {
        return defaultValue
      }
    },

    getLabel(field, application) {
      // to get simple text label set in the field
      if (typeof field.label === 'function') {
        return field.label.call(this, application)
      } else if (field.label) {
        return field.label
      } else {
        return false
      }
    },

    getVHtmlLabel(field, application) {
      // to get html label set in the field
      if (typeof field.vHtmlLabel === 'function') {
        return field.vHtmlLabel.call(this, application)
      } else if (field.vHtmlLabel) {
        return field.vHtmlLabel
      } else {
        return false
      }
    },

    getOptions(field, application) {
      if (typeof field.options === 'function') {
        return field.options.call(this, application, this.$store)
      } else if (field.options) {
        return field.options
      }
    },

    getReferenceDataSet(key) {
      let refData = this.$store.state.refData[key]
      return refData
    },   

    getSupportDocCategoryConfig(categoryName) {
      const oesProperties = this.$store.state.oesProperties
      return (
        oesProperties.supportingDocuments &&
        oesProperties.supportingDocuments[categoryName]
      )
    },

    getIdentityDocCategoryConfig(categoryName) {
      const oesProperties = this.$store.state.oesProperties
      return (
        oesProperties.identityProofDocuments &&
        oesProperties.identityProofDocuments[categoryName]
      )
    },

    getRequired(field, application) {
      if (typeof field.required === 'function') {
        return field.required(application)
      } else if (field.required) {
        return field.required
      }
    },
    

    getDescription(field, application) {
      if (!field.description) {
        return false
      } else if (typeof field.description === 'function') {
        return field.description.call(this, application, this.$store)
      } else if (field.description) {
        return field.description
      }
    },

    getVHtmlDescription(field, application) {
      if (typeof field.vHtmlDescription === 'function') {
        return field.vHtmlDescription.call(this, application, this.$store)
      } else if (field.vHtmlDescription) {
        return field.vHtmlDescription
      }
    },

    setValue(section, field, val, force) {
      const oVal = _get(this, `$store.state.application.${field.apiKey}`)
      if (oVal !== val || force) {
        this.$store.dispatch('set', [`application.${field.apiKey}`, val])

        if (field.onFieldSet && !field.onFieldSetAfterAlerts) {
          this.onFieldSet(field, val)
        }
        this.$store.dispatch('addAlert', { section, field })

        this.$store.dispatch('buildCounters')
        this.$store.dispatch('buildAlerts')

        if (field.onFieldSet && field.onFieldSetAfterAlerts) {
          this.onFieldSet(field, val)
        }

        this.$store
          .dispatch('saveApplicationSection', { section, type: '' })
          .catch(() => {
            this.$store.dispatch('set', ['saveStatus', null])
            this.$store.dispatch('set', [
              'error',
              new Error('Error when auto-saving: Could not reach server')
            ])

            this.$router.history.push('/error')
          })
      }
    },
    setValueNumber(section, field, val, force) {
      const oVal = _get(this, `$store.state.application.${field.apiKey}`)
      if (oVal !== val || force) {
       
        this.$store.dispatch('set', [`application.${field.apiKey}`, parseFloat(val)])

        if (field.onFieldSet && !field.onFieldSetAfterAlerts) {
          this.onFieldSet(field, parseFloat(val))
        }
        this.$store.dispatch('addAlert', { section, field })

        this.$store.dispatch('buildCounters')
        this.$store.dispatch('buildAlerts')

        if (field.onFieldSet && field.onFieldSetAfterAlerts) {
          this.onFieldSet(field, parseFloat(val))
        }

        this.$store
          .dispatch('saveApplicationSection', { section, type: '' })
          .catch(() => {
            this.$store.dispatch('set', ['saveStatus', null])
            this.$store.dispatch('set', [
              'error',
              new Error('Error when auto-saving: Could not reach server')
            ])

            this.$router.history.push('/error')
          })
      }
    },
    getCollection(apiKey) {
      try {
        return _get(this, `$store.state.application.${apiKey}`) || []
      } catch (ex) {
        return []
      }
    },

    addNewCollectionItem(field) {
      let collection = this.getCollection(field.apiKey)
      let collectionCounter = 1
      // make sure index is largest current index
      collection.map(item => {
        if (
          item.collectionItemUniqueId &&
          parseInt(item.collectionItemUniqueId) >= collectionCounter
        ) {
          collectionCounter = parseInt(item.collectionItemUniqueId) + 1
        }
      })
      // make sure all existing item in array has index
      collection = collection.map(item => {
        if (!item.collectionItemUniqueId) {
          item.collectionItemUniqueId = collectionCounter++
        }
        return item
      })

      // add to counter for unique ID
      let newItem = UTILS.clone(field.newItem)
      newItem.collectionItemUniqueId = collectionCounter++

      // attached new item to array
      collection.push(newItem)

      // save updated array to store
      return this.$store.dispatch('set', [
        'application.' + field.apiKey,
        collection
      ])
    }
  }
}
